import { ApiError } from "@/api/client";
import { UI } from "@/components/ui";

export function pageLoading(title = "加载中"): string {
  return `
    <div class="card p-10 flex flex-col items-center justify-center text-center min-h-[240px]">
      <div class="w-8 h-8 border-2 border-brand-200 border-t-brand-700 rounded-full animate-spin mb-3"></div>
      <div class="text-sm font-medium text-ink-800">${title}</div>
      <div class="text-xs text-ink-400 mt-1">正在从服务端拉取数据…</div>
    </div>
  `;
}

export function pageError(err: unknown, retryAttr = 'onclick="renderRoute()"'): string {
  const message = err instanceof ApiError ? err.message : err instanceof Error ? err.message : String(err);
  const code = err instanceof ApiError ? err.code : "ERROR";
  return UI.emptyState({
    icon: "alert",
    title: "加载失败",
    desc: `<span class="font-mono text-xs">${code}</span> · ${message}`,
    action: `<button ${retryAttr} class="btn-primary">重试</button>`,
  });
}

export type PageRenderResult = string | Promise<string>;

export async function resolvePageHtml(result: PageRenderResult): Promise<string> {
  return await result;
}
